export default function showChecklistOverlay() {
    const overlay = document.getElementById('checklist-overlay')
    overlay.style.display = 'flex'
  
    const closeBtn = overlay.querySelector('.close-btn')
    closeBtn.onclick = () => {
      overlay.style.display = 'none'
    }
  }
  